export const cardSx = {
  maxWidth: '100%',
  width: '100%',
  minWidth: 0,
};

export const itemSx = {
  backgroundColor: 'background.brandSubtle',
  border: '1px dashed',
  borderColor: 'border.default',
  borderRadius: 2,
  p: 1,
};

export const itemHeaderSx = {
  alignItems: 'center',
  columnGap: 4,
  flexWrap: 'wrap',
  rowGap: 1,
};

export const itemToggleButtonSx = {
  alignSelf: 'stretch',
  backgroundColor: 'transparent',
  border: 0,
  borderRadius: 0,
  cursor: 'pointer',
  minWidth: 20,
  p: 0,
  position: 'relative',
  width: 20,
  '&::after': {
    border: '1px solid',
    borderColor: 'primary.main',
    borderTop: 0,
    borderLeft: 0,
    content: '""',
    display: 'block',
    height: 6,
    left: 4,
    position: 'absolute',
    top: '49%',
    transform: 'translateY(-70%) rotate(45deg)',
    transformOrigin: 'center',
    transition: 'transform 0.3s',
    width: 6,
  },
  '&:hover::after': {
    transform: 'translateY(-80%) rotate(45deg) scale(1.15)',
  },
};

export const itemToggleButtonOpenSx = {
  '&::after': {
    top: '49%',
    transform: 'translateY(-20%) rotate(225deg)',
  },
  '&:hover::after': {
    transform: 'translateY(-20%) rotate(225deg) scale(1.15)',
  },
};
